import React, { useState } from 'react';
import InvoiceConfigList from './components/invoiceConfigList';
import InvoiceConfigModal from './components/invoiceConfigModal';
import useInvoiceConfigState from './hooks/useInvoiceConfigState';
import { message } from 'antd';

const InvoiceConfig = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const { invoiceConfigs, loading, addOrUpdate } = useInvoiceConfigState();

  const [modalOpen, setModalOpen] = useState(false);
  const [editingInvoiceConfig, setEditingInvoiceConfig] = useState(null);

  const handleAdd = () => {
    setEditingInvoiceConfig(null);
    setModalOpen(true);
  };

  const handleEdit = (setting) => {
    setEditingInvoiceConfig(setting);
    setModalOpen(true);
  };

  const handleSave = async (setting) => {
    const response = await addOrUpdate(setting);
    if (response?.success) {
      setModalOpen(false);
      let toastMessage = 'Invoice Config created successfully';
      if (editingInvoiceConfig && editingInvoiceConfig.id) {
        toastMessage = 'Invoice Config updated successfully';
      }
      messageApi.success(toastMessage, 5);
    }
    return response;
  };

  return (
    <>
      {contextHolder}
      <InvoiceConfigList
        settings={invoiceConfigs}
        loading={loading}
        onEdit={handleEdit}
        onAdd={handleAdd}
      />
      <InvoiceConfigModal
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={editingInvoiceConfig}
        settings={invoiceConfigs}
      />
    </>
  );
};

export default InvoiceConfig;
